export default function googleEcommercePlugin() {
  return {
    name: 'google-ecommerce-plugin',

    config: {},

    initialize: () => {},

    page: () => {},

    track: ({ payload }) => {
      const { event } = payload;

      if (event === 'Purchase Succeeded' && window.ga) {
        const { orderId, program, plan, calculatedAmount, sku } = payload;

        window.ga('ec:addProduct', {
          id: sku,
          name: plan,
          category: program,
          brand: 'Precision Nutrition',
          price: calculatedAmount,
          quantity: 1,
        });

        window.ga('ec:setAction', 'purchase', {
          id: orderId,
          revenue: calculatedAmount,
        });
      }
    },

    identify: () => {},

    loaded: () => {
      return !!window.ga;
    },
  };
}
